export { default } from "./logo";
